<template>
    <div class="flex-panel" :style="'height:' + height + 'px'">
        <div v-for="(item,index) in items" :key="index" style="margin-left: 2px;">
            <c-tag
                :width            = "width"
                :label            = "item.responsibility.name"
                :active           = "item.selected"
                :background-color = "backgroundColor"
                class             = "tag"
            />
        </div>
    </div>
</template>

<script>

import CTag from "@/modules/core/components/utils/CTag";
export default {
    name: "RResponsibilities",
    components: {
        CTag,
    },

    props: {
        items: {

        },
        width: {

        },
        height: {
            required: false,
            type: Number,
            default: function () {
                return 60;
            }
        },
        backgroundColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },
    },

    data: () => ({
    }),

    computed: {
        preview () {
            return this.items.slice(0,3);
        },
    },
}
</script>

<style scoped>

.flex-panel {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-end;
}

.tag {
    flex-grow: 1;
    width: 100%
}

::v-deep .black {
    color: black!important;
}

</style>